import { get } from 'framework/api/http';
import { useQuery } from 'react-query';

/* Get user profile */
export const getUserProfile = async () => {
  const res = await get(`/creator-api/get_profile`);
  return res?.data || [];
};

/* Use Query as a Hook */
export const useGetUserProfile = (onSuccess: any, onError: any) => {
  return useQuery('user-profile', getUserProfile, {
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 0,
    onSuccess,
    onError,
  });
};

export default useGetUserProfile;
